import { FormEvent, useState } from 'react';
import { api, ErroApi } from '../lib/api';
import { Alerta, Botao, Campo, Cartao } from '../componentes/Interface';

/**
 * Formulario aberto, sem login: e a porta de entrada do visitante.
 * Nada aqui da acesso ao sistema — os dados vao para a area da recepcao.
 */
export default function FormularioVisitante() {
  const [nome, setNome] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [instagram, setInstagram] = useState('');
  const [sexo, setSexo] = useState('');
  const [equipe, setEquipe] = useState('');
  const [interesse, setInteresse] = useState('');
  const [observacao, setObservacao] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [pronto, setPronto] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function enviar(e: FormEvent) {
    e.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      const r = await api<{ mensagem: string }>('/visitantes', {
        method: 'POST',
        body: JSON.stringify({
          nome: nome.trim(),
          whatsapp: whatsapp.trim(),
          instagram: instagram.trim() || null,
          sexo: sexo || null,
          equipe: equipe.trim() || null,
          interesse: interesse.trim() || null,
          observacao: observacao.trim() || null,
        }),
      });
      setPronto(r.mensagem);
    } catch (e) {
      setErro(e instanceof ErroApi ? e.message : 'Não consegui enviar. Tente de novo.');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="flex min-h-full items-center justify-center bg-fundo px-4 py-10">
      <div className="w-full max-w-lg">
        <div className="mb-6 flex flex-col items-center text-center">
          <img
            src="/logo-fundo.png"
            alt="Sara Osasco"
            className="h-20 w-20 rounded-2xl object-cover shadow-cartao"
          />
          <h1 className="mt-3 text-2xl font-bold text-tinta-900">Que bom ter você aqui!</h1>
          <p className="mt-1 text-sm text-tinta-500">
            Deixe seu contato para a gente te receber melhor da proxima vez.
          </p>
        </div>

        <Cartao>
          {pronto ? (
            <div className="space-y-4 text-center">
              <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-tinta-900 text-2xl text-white">
                ✓
              </span>
              <p className="text-lg font-semibold text-tinta-900">{pronto}</p>
              <p className="text-sm text-tinta-500">
                Em breve alguem da nossa equipe fala com voce pelo WhatsApp.
              </p>
              <Botao
                variante="secundario"
                onClick={() => {
                  setPronto(null);
                  setNome('');
                  setWhatsapp('');
                  setInstagram('');
                  setSexo('');
                  setEquipe('');
                  setInteresse('');
                  setObservacao('');
                }}
              >
                Preencher para outra pessoa
              </Botao>
            </div>
          ) : (
            <form onSubmit={enviar} className="space-y-4">
              {erro && <Alerta>{erro}</Alerta>}

              <Campo
                rotulo="Nome completo"
                required
                value={nome}
                onChange={(e) => setNome(e.target.value)}
              />

              <div className="grid gap-4 sm:grid-cols-2">
                <Campo
                  rotulo="WhatsApp"
                  required
                  inputMode="tel"
                  placeholder="(11) 90000-0000"
                  value={whatsapp}
                  onChange={(e) => setWhatsapp(e.target.value)}
                />
                <Campo
                  rotulo="Instagram (opcional)"
                  placeholder="@seuperfil"
                  value={instagram}
                  onChange={(e) => setInstagram(e.target.value)}
                />
              </div>

              <fieldset>
                <legend className="mb-2 text-sm font-medium text-tinta-700">Você e</legend>
                <div className="flex gap-2">
                  {[
                    { valor: 'homem', rotulo: 'Homem' },
                    { valor: 'mulher', rotulo: 'Mulher' },
                    { valor: 'prefiro_nao_dizer', rotulo: 'Prefiro não dizer' },
                  ].map((o) => (
                    <label
                      key={o.valor}
                      className={`flex-1 cursor-pointer rounded-xl border px-3 py-2 text-center text-sm transition ${
                        sexo === o.valor
                          ? 'border-tinta-900 bg-tinta-900/5 font-semibold text-tinta-900'
                          : 'border-tinta-200 text-tinta-600 hover:bg-tinta-100'
                      }`}
                    >
                      <input
                        type="radio"
                        name="sexo"
                        value={o.valor}
                        checked={sexo === o.valor}
                        onChange={(e) => setSexo(e.target.value)}
                        className="sr-only"
                      />
                      {o.rotulo}
                    </label>
                  ))}
                </div>
              </fieldset>

              <Campo
                rotulo="Qual equipe você e?"
                value={equipe}
                onChange={(e) => setEquipe(e.target.value)}
                placeholder="Ex.: Louvor, Mídia, Recepção, ou de outra igreja"
              />

              <Campo
                rotulo="Gostaria de servir em algum ministério? Se sim, qual?"
                value={interesse}
                onChange={(e) => setInteresse(e.target.value)}
                placeholder="Escreva o ministério, ou deixe em branco"
              />

              <label className="block">
                <span className="mb-1.5 block text-sm font-medium text-tinta-700">
                  Pedido de oracao (opcional)
                </span>
                <textarea
                  rows={3}
                  value={observacao}
                  onChange={(e) => setObservacao(e.target.value)}
                  placeholder="Escreva aqui o que você quer que a gente ore por você"
                  className="w-full rounded-xl border border-tinta-200 px-3.5 py-2.5 text-sm"
                />
              </label>

              <Botao type="submit" carregando={enviando} className="w-full">
                Enviar meus dados
              </Botao>

              <p className="text-center text-xs text-tinta-400">
                Seus dados ficam guardados so com a lideranca da igreja.
              </p>
            </form>
          )}
        </Cartao>
      </div>
    </div>
  );
}
